import { DOUGH_IMAGE } from "@/components/brand/BrandAssets";

const T = {
  eyebrow: { lv: "Piegāde un līdzņemšana", ru: "Доставка и самовывоз", en: "Delivery & pickup" },
  line1: { lv: "Tavs vakars.", ru: "Твой вечер.", en: "Your evening." },
  line2: { lv: "Tava Roze.", ru: "Твоя Roze.", en: "Your Roze." },
  delivery: { lv: "Piegāde", ru: "Доставка", en: "Delivery" },
  pickup: { lv: "Līdzņemšana", ru: "Самовывоз", en: "Pickup" },
  eta: { lv: "Piegāde 30–60 min", ru: "Доставка 30–60 мин", en: "Delivery in 30–60 min" },
  fee: { lv: "Piegādes maksa", ru: "Стоимость доставки", en: "Delivery fee" },
  free: { lv: "bez maksas no", ru: "бесплатно от", en: "free from" },
  min: { lv: "Minimālais pasūtījums", ru: "Минимальный заказ", en: "Minimum order" },
  pickupOffer: { lv: "Līdzņemšanai", ru: "При самовывозе", en: "Pickup" },
  closedNow: { lv: "Šobrīd pieņemam tikai iepriekšējus pasūtījumus", ru: "Сейчас принимаем только предзаказы", en: "Currently accepting pre-orders only" },
  paused: { lv: "Tiešsaistes pasūtījumi šobrīd ir apturēti", ru: "Онлайн-заказы временно приостановлены", en: "Online orders are currently paused" },
};

const eur = (v) => `€${Number(v).toFixed(2)}`;

const Stat = ({ label, value, testId }) => (
  <div className="border-t border-[#FDFBF7]/25 pt-4" data-testid={testId}>
    <p className="m-0 text-[0.68rem] tracking-[0.22em] uppercase text-[#FDFBF7]/60">{label}</p>
    <p className="m-0 mt-1.5 font-display text-2xl sm:text-[1.7rem] text-[#FDFBF7]">{value}</p>
  </div>
);

const DeliveryPickupSection = ({ language, deliveryConfig, restaurantStatus, onChoose }) => {
  const t = (k) => T[k][language] || T[k].lv;
  const paused = restaurantStatus?.is_manually_closed === true;
  const closed = restaurantStatus && !restaurantStatus.is_open && !paused;
  const discount = deliveryConfig?.pickup_discount_percent;

  return (
    <section id="delivery-section" className="scroll-mt-20 relative w-full overflow-hidden bg-[#1C1917] text-[#FDFBF7]" aria-labelledby="delivery-heading" data-testid="delivery-pickup-section">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[640px]">
        <div className="relative aspect-[4/3] sm:aspect-[16/9] lg:aspect-auto lg:min-h-full order-1 lg:order-2">
          <img src={DOUGH_IMAGE} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover object-[50%_62%] lg:object-[50%_40%]" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1C1917]/40 to-transparent hidden lg:block" aria-hidden="true" />
        </div>

        <div className="order-2 lg:order-1 px-5 sm:px-8 lg:pl-[8%] lg:pr-16 py-20 sm:py-28 flex flex-col justify-center">
          <p className="rz-eyebrow !text-[#FDFBF7]/60 m-0 mb-6">{t("eyebrow")}</p>
          <h2 id="delivery-heading" className="font-display text-[clamp(2.4rem,5.5vw,4.4rem)] leading-[1.02] tracking-[-0.01em] m-0">
            {t("line1")}<br /><span className="italic text-[#FDFBF7]/90">{t("line2")}</span>
          </h2>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button onClick={() => onChoose("delivery")} className="rz-btn rz-btn--light w-full sm:w-auto min-w-[200px]" data-testid="choose-delivery-button">{t("delivery")}</button>
            <button onClick={() => onChoose("pickup")} className="rz-btn rz-btn--light-outline w-full sm:w-auto min-w-[200px]" data-testid="choose-pickup-button">{t("pickup")}</button>
          </div>

          <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-6 sm:gap-8 max-w-[560px]" data-testid="delivery-info">
            <Stat label={t("eta")} value="30–60 min" testId="delivery-eta" />
            {deliveryConfig && <Stat label={`${t("fee")} · ${t("free")} ${eur(deliveryConfig.free_delivery_threshold)}`} value={eur(deliveryConfig.delivery_fee)} testId="delivery-fee" />}
            {discount ? <Stat label={t("pickupOffer")} value={`−${Number(discount).toFixed(0)}%`} testId="pickup-discount" /> : null}
            {deliveryConfig && <Stat label={t("min")} value={eur(deliveryConfig.minimum_order_amount)} testId="delivery-min" />}
          </div>

          {paused && <p className="m-0 mt-8 rz-eyebrow !text-[#FDFBF7]/70">{t("paused")}</p>}
          {closed && <p className="m-0 mt-8 rz-eyebrow !text-[#FDFBF7]/70">{t("closedNow")}</p>}
        </div>
      </div>
    </section>
  );
};

export default DeliveryPickupSection;
